export default __webpack_public_path__ + "static/media/NPPES.2fc0e64b.png";